<template>
  <div 
    v-dragscroll.y
    :style="{ 'background-color': `${customBGColorContent ? customBGColorContent : BGColorContent}`, 'width': `${mainFormWidth}px`, '--secondary-color': BGColor }"
    style="height: 980px;overflow-y:scroll;"
    class="main-body-totem"
  >
    <menu-header
      v-if="name"
      :name="name"
      :isSecundary="isSecundary"

    />
    <div v-if="desktopView" >
      <v-layout
        wrap
        v-for="(row, indexRows) in desktopView"
        :key="`rows${indexRows}`"
      >
      <v-flex
        v-for="(column, indexColumn) in row.Columns"
        :key="`column${indexColumn}`"
        v-bind="{ [column.Type]: true }"
      >
        <div 
          v-for="item in column.Contents"
          :key="`content${item.ID}`"
        >
          <items
            :item="item"
            :menuID="menu.ID"
            :isMobile="false"
            :columnType="column.Type"
            :customTextColorContent="customTextColorContent"
          />
        </div>
      </v-flex>
      </v-layout>
    </div>
    <div
    v-else
      v-for="item in isSimulation && editTMP && id === editTMP.ID && contents ? contents : apiContents"
      :key="`content${item.ID}`"
    >
      <items
        :item="item"
        :menuID="menu.ID"
        :isMobile="false"
        :customTextColorContent="customTextColorContent"
      />
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
import { dragscroll } from 'vue-dragscroll'
  import MenuHeader from '../MenuHeader'
  import api from '@/services/api'
  import constants from '@/constants'
  import utils from '@/services/utils'
  import Items from '@/components/Items.vue'
  import dview from '@/services/dview-service'
      import axios from 'axios'
  export default {
    directives: {
      dragscroll
    },
    components: {
      MenuHeader,
      Items
    },
    props: {
      menu: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
      apiContents: [],
      isSecundary: false,
      name: null,
      desktopView: false,
      cssProps: {
      },
    }),
    computed: {
      ...mapState('app',['editTMP', 'contents', 'BGColorContent', 'ColorContent', 'mainFormWidth', 'BGColor']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isMenu () {
        return constants.menusRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      },
      touchPublic () {
         return this.$route.query.touchPublic ? true : false
      },
      title () { return 2 },
      isTest () {
        return this.$route.query.test
      },
      customBGColorContent () {
        return this.menu.BGColorContent
      },
      customTextColorContent () {
        return this.menu.TextColorContent
      }
    },
    watch: {
      menu: {
        handler: function (newValue) {
          this.isSecundary = newValue.isSecundary
          this.name = newValue.Name
          this.getContent(newValue.ID)
        },
        deep: true
      }
    },
    mounted () {
      const aux = new Date()

      //const ini = aux.getTime()/1000
      const ini = '1654108501'
      //const end =  new Date(aux.setTime(aux.getTime() + 1 * 60 * 60 * 1000)).getTime()/1000
      const end = '1654245301'
      axios.post('https://www.aena.es/sites/Satellite?pagename=AENA_ConsultarVuelos&airport=TFS&flightType=S&l=es_ES')
      .then (response => {
        console.log(response)
      }).catch(err=>{
        console.log(err)
      })
      const url = `https://opensky-network.org/api/flights/arrival?airport=EDSB&begin=${ini|0}&end=${end|0}`
      const url2 = `https://opensky-network.org/api/flights/arrival?airport=GCTS&begin=${ini|0}&end=${end|0}`
      console.log('url',url, url2,
        new Date(1654108501000),
        new Date(1654245301000),
 ''     )

      this.isSecundary = this.menu.isSecundary
      this.name = this.menu.Name
      this.getContent(this.menu.ID)
    },
    methods: {
      getContent(id) {
        this.desktopView = [] // solve bug pdf translate error
        // alert(id)
        //api.getAll(`contents`, false, null, null, null, id).then(response => {
        api.getAll(`contents`, false, null, null, null, id.concat(this.isTest ? '/test': '')).then(response => {
          // this.apiContents = response 
          response = response.filter(x => !x.HideTotem)
          this.apiContents = response.map(item => {
            item.IsActive = dview.isActive(item)
            return (item)
          }).filter(x => x.IsActive.date && x.IsActive.time || this.isSimulation)
          api.getAll(`menus/desktop-view`, false, null, null, null, id).then(responseDesktopView => {
            let rdv = responseDesktopView.struct ? JSON.parse(responseDesktopView.struct) : null
            if (rdv) {
              const ids = []
              for (let i = 0; i < rdv.length; i++) {
                for (let j = 0; j < rdv[i].Columns.length; j++) {
                  for (let k = 0; k < rdv[i].Columns[j].Contents.length; k++) {

                    const aux = this.apiContents.filter(x=>x.ID === rdv[i].Columns[j].Contents[k].ID).shift()
                    if(aux) {
                      rdv[i].Columns[j].Contents[k] = aux //this.apiContents.filter(x=>x.ID === rdv[i].Columns[j].Contents[k].ID) [0]
                      ids.push(rdv[i].Columns[j].Contents[k].ID) // utilizado para obtener los ids del contenido configurado
                    }
                  } 
                } 
              }
              // Añadimos al una fila al final para todo el contenido no actualizado
              rdv.push({
                Columns: [
                  {
                    Type: 'xs12',
                    Contents: this.apiContents.filter(x=>ids.indexOf(x.ID) < 0)
                  }
                ]
              })
            }
            this.desktopView = rdv
          })
          // api.getAll(`contents`, false, null, null, null, id).then(response => {
          //   this.apiContents = response 
          // })
        })
      }
    }
  }
</script>
<style scoped>
.main-body-totem::-webkit-scrollbar {
  width: 30px;
  display: auto;
}
.main-body-totem::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
}
.main-body-totem::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
    /*
  border: 0.5px solid var(--secondary-color);
    */
}
.main-body-totem::-webkit-scrollbar-track  {
  /*

  border: 0.5px solid var(--secondary-color);
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.9);
    */
    background-color: white;
}
.main-body-totem::-webkit-scrollbar-thumb{
    background-color: var(--secondary-color);
    /*
    background-image: -webkit-linear-gradient(90deg,transparent,rgba(0, 0, 0, 0.4) 50%,transparent,transparent)
    */
}
.main-body-totem {
  overflow-y: scroll !important;
  overflow-x: hidden !important;
  scrollbar-color: rgba(0, 0, 0, .5) rgba(0, 0, 0, 0) !important;
  -ms-overflow-style: auto;  /* IE and Edge */
}
</style>
